export function sanitizeNumericValue(
  value: string,
  variant: "number" | "currency",
): string {
  if (variant === "number") {
    return value.replace(/[^\d]/g, "");
  }

  const stripped = value.replace(/[^\d.]/g, "");
  const dot = stripped.indexOf(".");
  if (dot === -1) return stripped;
  return `${stripped.slice(0, dot + 1)}${stripped.slice(dot + 1).replace(/\./g, "")}`;
}

/** Insert thousand separators into a sanitized currency string. */
export function formatCurrencyInputValue(value: string): string {
  const sanitized = sanitizeNumericValue(value, "currency");
  if (!sanitized) return "";

  const hasDot = sanitized.includes(".");
  const [integerPart = "", decimalPart = ""] = sanitized.split(".");
  const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return hasDot ? `${formattedInt}.${decimalPart}` : formattedInt;
}
